export const HtmlEntities = {
    MDASH: String.fromCharCode(8212) /* &mdash; */,
    NDASH: String.fromCharCode(8211) /* &ndash; */,
    NBSP: String.fromCharCode(160) /* &nbsp; */
}
